export default __webpack_public_path__ + "locales/ko-KR/DataReassignmentDialog.json?hash=d029c70c592046c0e43ea46b7f64ae8c";